export default "__VITE_ASSET__655ca198__"